import { render, staticRenderFns } from "./StepColumns.vue?vue&type=template&id=09e3b56d&scoped=true"
import script from "./StepColumns.vue?vue&type=script&lang=js"
export * from "./StepColumns.vue?vue&type=script&lang=js"
import style0 from "./StepColumns.vue?vue&type=style&index=0&id=09e3b56d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e3b56d",
  null
  
)

export default component.exports